// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.periodicity-container {
  display: flex;
  flex-direction: column;
  background-color: #f3f5f7;
  color: #343839;
  border-radius: 20px;
  padding: 20px;
  margin-right: 10px;
  margin-bottom: 20px;
  width: 232px;
  height: 84px;
  cursor: pointer;
}
.periodicity-container.active {
  border: 2px solid #0084ff;
  background-color: #fefefe;
  padding: 18px;
}
.periodicity-container .periodicity-pay-text {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.periodicity-container .periodicity-pay-text .periodicity-save {
  background-color: rgba(63, 221, 120, 0.15);
  color: #0c923c;
}`, "",{"version":3,"sources":["webpack://./src/Components/PeriodicityOption/periodicityoption.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AACF;AACE;EACE,yBAAA;EACA,yBAAA;EACA,aAAA;AACJ;AAEE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAAJ;AAEI;EACE,0CAAA;EACA,cAAA;AAAN","sourcesContent":[".periodicity-container {\n  display: flex;\n  flex-direction: column;\n  background-color: #f3f5f7;\n  color: #343839;\n  border-radius: 20px;\n  padding: 20px;\n  margin-right: 10px;\n  margin-bottom: 20px;\n  width: 232px;\n  height: 84px;\n  cursor: pointer;\n\n  &.active {\n    border: 2px solid #0084ff;\n    background-color: #fefefe;\n    padding: 18px;\n  }\n\n  .periodicity-pay-text {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n\n    .periodicity-save {\n      background-color: rgba(63, 221, 120, 0.15);\n      color: #0c923c;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
